const login = {
  // Brand
  brandTitle: 'استثنائي',
  brandSubtitle: 'التعلّم',
  brandTagline: 'مستقبلي · بجودة طبية · برعاية',
  heroTitle: 'تمكين رحلة<br />كل متعلم',
  heroDescription: 'منصة موحدة تربط المعالجين والمعلمين والمنسقين والأسر — مبنية حول الطفل، وليس الأعمال الورقية.',
  // Feature pills
  feature1Title: 'إدارة الحالات الطلابية',
  feature1Sub: 'ملفات وسجلات شاملة',
  feature2Title: 'متابعة جلسات العلاج',
  feature2Sub: 'ملاحظات وتقييمات وتقدم',
  feature3Title: 'جدولة ذكية',
  feature3Sub: 'كشف التعارضات تلقائياً',
  feature4Title: 'تحليلات التقدم',
  feature4Sub: 'رؤى المجالات التنموية',
  // Trust badges
  trustAccessible: 'متوافق مع WCAG-AA',
  trustEncrypted: 'مشفر بالكامل',
  trustNDIS: 'متوافق مع NDIS',
  // Login form
  welcomeBack: 'مرحباً بعودتك',
  signInSubtitle: 'سجل الدخول إلى حسابك في منصة استثنائي للتعلّم',
  signInAs: 'تسجيل الدخول كـ',
  signIn: 'تسجيل الدخول',
  signingIn: 'جارٍ تسجيل الدخول…',
  enterPassword: 'أدخل كلمة المرور',
  forgotPassword: 'نسيت كلمة المرور؟',
  // Demo section
  demoCredentials: 'بيانات تجريبية',
  tryDemoTitle: 'جرّب العرض التوضيحي',
  tryDemoDescription: 'استخدم أي بريد إلكتروني + كلمة مرور (6 أحرف على الأقل) مع دور محدد لاستكشاف المنصة.',
  // Forgot password flow
  resetPasswordTitle: 'إعادة تعيين كلمة المرور',
  resetPasswordDescription: 'أدخل البريد الإلكتروني لحسابك وسنرسل لك رابط إعادة تعيين آمن.',
  sendResetLink: 'إرسال رابط التعيين',
  backToSignIn: 'العودة إلى تسجيل الدخول',
  emailSentTitle: 'تم إرسال البريد!',
  emailSentDescription: 'تفقد صندوق الوارد للعثور على رابط التعيين. جارٍ إعادة التوجيه…',
  // Validation
  emailRequired: 'البريد الإلكتروني مطلوب',
  emailInvalid: 'يرجى إدخال بريد إلكتروني صحيح',
  passwordRequired: 'كلمة المرور مطلوبة',
  passwordMinLength: 'يجب أن تتكون كلمة المرور من 6 أحرف على الأقل',
  // Role labels
  roleAdmin: 'مدير',
  roleCoordinator: 'منسق',
  roleTherapist: 'معالج',
  roleTeacher: 'معلم',
  // Footer
  privacyPolicy: 'سياسة الخصوصية',
  termsOfService: 'شروط الخدمة',
};

export default login;